import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../web/components-v2/Theme/theme';
import { APP_BAR_HEIGHT } from '../../../web/components-v2/AppLayout/components/AppBar/styles';
import { CssSelectors } from '../../../web/styles/styles';
import { brandPrimaryHover } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	appBar: {
		// Same blue as the page behind it, so the bar reads as part of the canvas rather than a band
		// across it. No bottom border for the same reason — the sub-bar below supplies the only division.
		background: brandPrimaryHover,
		boxSizing: 'border-box',
		height: APP_BAR_HEIGHT,
		minHeight: APP_BAR_HEIGHT,
		padding: `0 ${SPACE[24]}px`,
		zIndex: 5,
	},
	navItem: {
		flex: 1,
	},
	rightAccessoryContainer: {
		alignItems: 'center',
		display: 'flex',
		zIndex: 2,
		...CssSelectors.allChildren({ marginLeft: SPACE[20] }, ':not(:first-child)'),
	},
});
